import { Route } from "@angular/router";

import { environment } from "@local/environments/environment";

import { routes as componentZooRoutes } from "./component-zoo";
import { routes as goLoginRoutes } from "./go-login";
import { routes as noPermissionRoutes } from "./no-permission";
import { routes as notFoundRoutes } from "./not-found";
import { routes as testPageRoutes } from "./test-page";

export const routes: Route[] = [
  ...goLoginRoutes,
  ...notFoundRoutes,
  ...noPermissionRoutes,
  ...(!environment.production ? [...testPageRoutes, ...componentZooRoutes] : [])
];

const LANTERN_ROUTE_PATHS = routes
  .filter((route) => route.path != null)
  .map((route) => {
    return route.path!.startsWith("/") ? route.path! : `/${route.path}`;
  });

export function isLanternRoute(pathToCheck: string): boolean {
  return !LANTERN_ROUTE_PATHS.some((path) => pathToCheck.startsWith(path));
}
